import $ from 'jquery';

$('.faq__item').each(function () {
    $(this).on('click', function(){

        $(this).toggleClass('active');
        
    });
});

if ($(window).width() < 600) {
    $('.footermain .footermain__title').on('click tap', function(){
        $(this).toggleClass('clicked');
        $(this).parent().find('.menuf').slideToggle();
    });
}
$('.zol').on('click', function(e){
    // e.preventDefault();
    $('html, body').animate({
        scrollTop: $('#formdom').offset().top - 100
    }, 500, 'linear');
});
$('.ask').on('click', function(e){
    // e.preventDefault();
    $('html, body').animate({
        scrollTop: $('#formdom').offset().top - 100
    }, 500, 'linear');
});
$('.backtomenu').on('click', function(e){
    // e.preventDefault();
    $('html, body').animate({
        scrollTop: $('#menuincat').offset().top - 100
    }, 500, 'linear');
});

$('.m__r--item').on('click', function(){
    let rid = $(this).data('m');
    $('.m__r--item').removeClass('act');
    $(this).addClass('act');
    $('html, body').animate({
        scrollTop: $('#menulist').offset().top - 100
    }, 500, 'linear');
    $('.m__item').each(function(){
        let lid = $(this).data('m');
        // $('.m__item').removeClass('active');
        if (lid == rid){
            $(this).addClass('active');
        }else{
            $(this).removeClass('active');

        }
    });
});